module.exports = __webpack_public_path__ + "img/sert1.36d22985.png";